import { render } from "./Anesthesiology.vue?vue&type=template&id=0ebf4409&scoped=true"
import script from "./Anesthesiology.vue?vue&type=script&lang=ts"
export * from "./Anesthesiology.vue?vue&type=script&lang=ts"

import "./Anesthesiology.vue?vue&type=style&index=0&id=0ebf4409&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0ebf4409"

export default script